<template>
  <div id="main" class="login_main">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'public-layout'
}
</script>
